import React from 'react';
import { Check, Loader2 } from 'lucide-react';
import { cn } from '../../utils/cn';

interface CheckboxProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  checked?: boolean;
  loading?: boolean;
  label?: string;
}

export function Checkbox({ 
  checked = false, 
  loading = false,
  label,
  className,
  ...props 
}: CheckboxProps) {
  return (
    <button
      type="button"
      role="checkbox"
      aria-checked={checked}
      className={cn(
        "inline-flex items-center gap-2 transition-all duration-200",
        className
      )}
      {...props}
    >
      <div className={cn(
        "w-4 h-4 rounded flex items-center justify-center transition-all duration-200",
        checked 
          ? "bg-gray-600 border-gray-600" 
          : "border border-gray-400 bg-gray-200",
        loading 
          ? "opacity-50 cursor-not-allowed" 
          : "hover:border-gray-500"
      )}>
        {loading ? (
          <Loader2 className="w-3 h-3 text-white animate-spin" />
        ) : checked ? (
          <Check className="w-3 h-3 text-white stroke-[3]" />
        ) : null}
      </div>
      {label && (
        <span className="text-sm font-normal">
          {label}
        </span>
      )}
    </button>
  );
}